export const MfaErrorStates = Object.freeze({
  CodeMismatchException: 'CodeMismatchException',
  NotAuthorizedException: 'NotAuthorizedException',
})
